import { useState } from "react";
import { Dropdown, InstallIcon, useMedia } from "../Menu";
import { hideNote, howTo, noteHidden, noteWay, PHONE_OR_TOUCH, promptInstall, useInstall } from "./install";

/** The header button, next to the Sync badge on the phone and the desktop; on iOS it opens the Share steps. */
export function InstallButton() {
  const { can, way, agent } = useInstall();
  if (way === "share") {
    return (
      <Dropdown
        className="install-how"
        testId="install-app"
        label="Install app"
        summary={
          <>
            <InstallIcon size={22} />
            <span className="install-label">Install app</span>
          </>
        }
      >
        {() => (
          <p className="install-how-text" data-testid="install-how">
            {howTo("share", agent)}
          </p>
        )}
      </Dropdown>
    );
  }
  if (!can) return null;
  return (
    <button type="button" className="install-button" data-testid="install-app" aria-label="Install app" title="Install app" onClick={() => void promptInstall()}>
      <InstallIcon size={22} />
      <span className="install-label">Install app</span>
    </button>
  );
}

/** One line at the top of Today and Record a visit; Not now hides it for 30 days. */
export function InstallNote() {
  const { way: found, agent } = useInstall();
  const way = noteWay(found, useMedia(PHONE_OR_TOUCH));
  const [hidden, setHidden] = useState(noteHidden);
  if (hidden || way === "none") return null;
  return (
    <p className="install-note" data-testid="install-note" data-way={way}>
      {way === "button" ? (
        <>
          Install Xflow on this device, so the route works with no signal.{" "}
          <button type="button" className="link" data-testid="install-note-app" onClick={() => void promptInstall()}>
            Install app
          </button>
        </>
      ) : (
        howTo(way, agent)
      )}{" "}
      <button
        type="button"
        className="link"
        data-testid="install-not-now"
        onClick={() => {
          hideNote();
          setHidden(true);
        }}
      >
        Not now
      </button>
    </p>
  );
}
